module.exports = __webpack_public_path__ + "media/images/emblems/Fuerstenau_wappen-7fbdc7c4decffdc75c755cdbfb0bda9b.svg";